import { render, staticRenderFns } from "./WrapperSwiper.vue?vue&type=template&id=37d9395c&scoped=true&"
import script from "./WrapperSwiper.vue?vue&type=script&lang=js&"
export * from "./WrapperSwiper.vue?vue&type=script&lang=js&"
import style0 from "./WrapperSwiper.vue?vue&type=style&index=0&id=37d9395c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d9395c",
  null
  
)

export default component.exports